import React, { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CancelRounded } from '@mui/icons-material';
import myFunctions from '../myFunctions';

const PopUpTheComp = (props) => {


    const [open, setOpen] = useState(true);
    const [inputTxt, setInputTxt] = useState("");
    const [err, setErr] = useState((props.errorMsg == "") ? false : true);

    useEffect(() => {

    }, [])

    const saveMe = () => {
        props.okClick();
        handleClose();

    };


    const handleClose = () => {
        // props.cancelClick();
    };

    const closeIt = () => {
        if (typeof props.closePop === 'function') props.closePop();
    };

    myFunctions.useEscapeKey(closeIt);

    return (
        <Dialog open={open} className={`popDiagBlock ${props.cssStyl ? props.cssStyl : ""}`}>
            <button type="button" className={"btnReset closePopWinBtn"} aria-label="סגור" onClick={closeIt} >
                <CancelRounded className={"inBlack popUpCloseBtn pointing"} aria-hidden="true" />
            </button>
            {props.Title != "" ?
                <DialogTitle className={`theTitlePop ${props.titleCss ? props.titleCss : ""}`}>
                    {props.Title.map((txtItm, index) => {
                        return (
                            <span key={index} >{txtItm}<br /></span>
                        )
                    })}</DialogTitle>
                : ""}
            <DialogContent>
                <DialogContentText component="div">
                    {props.theInsideComp}
                </DialogContentText>

                {err ? <div role="alert" style={{ color: 'red', fontWeight: 'bold' }}>{props.errorMsg}</div> : ""}

            </DialogContent>
            <DialogActions >
                {/* 
                <button type="button" className="centerMe btn btn-success btnPopRegular" onClick={() => { props.okClick(); handleClose(); }}>
                    {(props.BtnTxt != null) ? props.BtnTxt : "המשך"}</button> */}
            </DialogActions>
            <DialogActions >
                {props.btnClick2 != null ?
                    <>
                        <span>&nbsp;&nbsp;</span>
                        <button type="button" className="btn-success btnPopRegular btnPopRegularSec" onClick={() => { props.btnClick2(); handleClose(); }}>
                            {(props.BtnTxt2 != null) ? props.BtnTxt2 : "ביטול"}</button>
                    </>
                    : ""}
            </DialogActions>
        </Dialog >

    );
}

export default PopUpTheComp;